var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("role-tab", {
        attrs: {
          tabs: {
            // haveBind 表示是否要用 binds中的数据
            haveBind: false,
            binds: []
          }
        },
        on: { change: _vm.tabHand }
      }),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "box-wrap" },
        [
          _vm.defalutChapter.sealName
            ? _c("div", { staticClass: "temone" }, [
                _c("div", { staticClass: "t-box" }, [
                  _c("img", {
                    staticClass: "y-img",
                    attrs: {
                      src: _vm.fileOperShow(_vm.defalutChapter.sealFile)
                    }
                  })
                ]),
                _c(
                  "p",
                  {
                    attrs: {
                      title:
                        _vm.defalutChapter.sealName +
                        "(ID:" +
                        _vm.defalutChapter.corpSealId +
                        ")"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.defalutChapter.sealName +
                            "(ID:" +
                            _vm.defalutChapter.corpSealId +
                            ")"
                        ) +
                        "\n      "
                    )
                  ]
                ),
                (_vm.isInDingTalk
                ? _vm.defalutChapter.dingTalkFlow
                : _vm.defalutChapter.flowDetail)
                  ? _c(
                      "div",
                      { staticClass: "info_box" },
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: { placement: "top-start", trigger: "click" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  padding: "10px",
                                  "font-weight": "bold"
                                }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.isInDingTalk
                                          ? _vm.defalutChapter.dingTalkFlow
                                              .flowName
                                          : _vm.defalutChapter.flowDetail
                                              .flowName
                                      ) +
                                      "\n                "
                                  )
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      height: "125px",
                                      "overflow-y": "scroll"
                                    }
                                  },
                                  [
                                    _c("approval-process", {
                                      attrs: {
                                        flowInfo: _vm.computeInfo(
                                          _vm.isInDingTalk
                                            ? _vm.defalutChapter.dingTalkFlow
                                            : _vm.defalutChapter.flowDetail
                                        ),
                                        orderFlag: _vm.isInDingTalk
                                          ? _vm.defalutChapter.dingTalkFlow
                                              .flowType
                                          : _vm.defalutChapter.flowDetail
                                              .orderFlag
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "approve_info",
                                attrs: { slot: "reference" },
                                slot: "reference"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isInDingTalk
                                      ? _vm.defalutChapter.dingTalkFlow.flowName
                                      : _vm.defalutChapter.flowDetail.flowName
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm.chapterList && _vm.chapterList.length > 0
            ? _vm._l(_vm.chapterList, function(item, index) {
                return _c("div", { key: index, staticClass: "temone" }, [
                  _c("div", { staticClass: "t-box" }, [
                    _c("img", {
                      staticClass: "y-img",
                      attrs: { src: item.signUrl, title: item.sealName }
                    })
                  ]),
                  _c(
                    "p",
                    {
                      attrs: {
                        title: item.sealName + "(ID:" + item.corpSealId + ")"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            item.sealName + "(ID:" + item.corpSealId + ")"
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  (_vm.isInDingTalk
                  ? item.dingTalkFlow
                  : item.flowDetail)
                    ? _c(
                        "div",
                        { staticClass: "info_box" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top-start",
                                trigger: "click"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    padding: "10px",
                                    "font-weight": "bold"
                                  }
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.isInDingTalk
                                            ? item.dingTalkFlow.flowName
                                            : item.flowDetail.flowName
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        height: "125px",
                                        "overflow-y": "scroll"
                                      }
                                    },
                                    [
                                      _c("approval-process", {
                                        attrs: {
                                          flowInfo: _vm.computeInfo(
                                            _vm.isInDingTalk
                                              ? item.dingTalkFlow
                                              : item.flowDetail
                                          ),
                                          orderFlag: _vm.isInDingTalk
                                            ? item.dingTalkFlow.flowType
                                            : item.flowDetail.orderFlag
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "approve_info",
                                  attrs: { slot: "reference" },
                                  slot: "reference"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isInDingTalk
                                        ? item.dingTalkFlow.flowName
                                        : item.flowDetail.flowName
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              })
            : !_vm.defalutChapter.sealName
            ? _c("no-data", {
                staticStyle: { "margin-top": "30px" },
                attrs: { text: "企业暂未授权印章给您，如需使用请联系管理员" }
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "com-title com-ht" }, [
      _c("i"),
      _vm._v("授权给我的印章")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b113f360", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b113f360","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/corpSet.vue
// module id = hA4C
// module chunks = 127